var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClass = function SvgClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M3 5.6C3 4.717 3.711 4 4.588 4h14.824C20.289 4 21 4.717 21 5.6v10.104c0 .883-.711 1.6-1.588 1.6H14.39c.56.75 1.32 1.43 1.936 1.919.374.296.202.777-.297.777H7.996c-.498 0-.67-.48-.297-.777.616-.49 1.376-1.17 1.936-1.919H4.588A1.594 1.594 0 0 1 3 15.704zm11.982 4.49c.48.28.48.978 0 1.257l-4.45 2.592a.72.72 0 0 1-1.08-.629V8.127a.72.72 0 0 1 1.08-.628z",
    clipRule: "evenodd"
  })));
};
export default SvgClass;